import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { connect, ReactReduxContext } from "react-redux";
import Modal from "../modal";
import {
  IAvailableForCreditCardSaveShift,
  ICompanyBank,
  IPropsAvailableForCreditCardSaveShift,
  IReduxProps,
} from "./interface";
import "./availableForCreditCardSaveShift.css";
import AddNewBankModal from "../addnewbankmodal";
import removeIcon from "../../resource/icons/cancel.svg";
import { RouteComponentProps } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state/index";

type Props = ReturnType<typeof mapStateToProps> &
  IPropsAvailableForCreditCardSaveShift;

const AvailableForCreditCardSaveShift = (
  props: IPropsAvailableForCreditCardSaveShift
) => {
  const [shift, setShift] = useState<IAvailableForCreditCardSaveShift>(
    props.shift
  );
  const [showModal, setShowModal] = useState(false);
  const [showPostFailedModal, setShowPostFailedModal] = useState(false);
  const [showAddNewBankModal, setShowAddNewBankModal] = useState(false);
  const shiftIdStr = shift.shiftId.toString();
  const year = shiftIdStr.slice(0, 4);
  const mouth = shiftIdStr.slice(4, 6);
  const day = shiftIdStr.slice(6, 8);
  const [languageData, setLanguageData] = useState<any>();
  // const { isLoggedIn, history } = props ?? {};

  const { store } = useContext(ReactReduxContext);

  // useEffect(() => {
  //   console.log(isLoggedIn);
  //   if (!isLoggedIn) {
  //     // store.dispatch(logout());
  //     history.push("/login");
  //   }
  // }, []);

  useEffect(() => {
    setShift(props.shift);
  }, [props.shift, props.shift.companyBanks]);

  useEffect(() => {
    setShowPostFailedModal(props.shift.isPostFailed);
  }, [props.shift.isPostFailed]);

  useEffect(() => {
    if (props.language) {
      setLanguageData(props.language);
    }
  }, [props.language]);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const toggleShowPostFailedModal = () => {
    setShowPostFailedModal(!showPostFailedModal);
  };

  const handleSaveInternally = () => {
    toggleShowModal();
    props.saveButtonClicked(shift.shiftId, shift.shiftsEntityId);
  };

  const handlePostFailedSaveInternally = () => {
    toggleShowPostFailedModal();
    props.saveButtonClicked(shift.shiftId, shift.shiftsEntityId);
  };

  const toggleAddNewBankModal = () => {
    setShowAddNewBankModal(!showAddNewBankModal);
  };
  const handleAddNewBank = (bank: ICompanyBank) => {
    toggleAddNewBankModal();
    props.newBankAdded(bank, shift.shiftId);
  };

  return (
    <div className={"component-custom-border"}>
      <table className={"table-custom-border"} key={"table1"}>
        <thead className={"first-thead"}>
          <tr>
            <th className={"custom-th-td"}>{languageData?.data?.shiftCreditCard?.shiftId}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftCreditCard?.date}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftCreditCard?.shiftNo}</th>
          </tr>
        </thead>
        <tbody key={"tbody1"}>
          <tr>
            <td className={"custom-th-td"}>{shift.shiftId}</td>
            <td className={"custom-th-td"}>
              {day}/{mouth}/{year}
            </td>
            <td className={"custom-th-td"}>{shiftIdStr.slice(-2)}</td>
          </tr>
        </tbody>
      </table>
      <table
        className={
          shift.isInputHidden
            ? "hiddenU table-custom-border"
            : "hiddenU.open table-custom-border"
        }
        key={"table2"}
      >
        <thead>
          <tr>
            <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftCreditCard?.bankName}</th>
            <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftCreditCard?.batchNo}</th>
            <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftCreditCard?.amount}</th>
          </tr>
        </thead>
        <tbody key={"tbody2"}>
          {shift.companyBanks.map((bank, index) => {
            if (bank.active === true) {
              return (
                <tr key={bank.bankName + index}>
                  <td className={"custom-th-td"}>{bank.bankName}</td>
                  <td className={"custom-th-td"}>
                    <input
                      key={index + "batch"}
                      value={bank.batchNo}
                      onChange={(element) =>
                        props.onBatchNoInputChange(
                          shift.shiftId,
                          bank.bankId,
                          element,
                          bank.domId
                        )
                      }
                    />
                  </td>
                  <td className={"custom-th-td"}>
                    <input
                      type="number"
                      key={index + "amount"}
                      value={bank.amount === 0 ? "" : bank.amount}
                      onChange={(element) =>
                        props.onAmountInputChange(
                          shift.shiftId,
                          bank.bankId,
                          element,
                          bank.domId
                        )
                      }
                    />
                  </td>
                  {bank.removable ? (
                    <td
                      style={{ padding: 0 }}
                      className={"remove-td"}
                      onClick={() => props.removeNewBank(bank, shift.shiftId)}
                    >
                      <img
                        title="Delete Row"
                        alt={"remove_image"}
                        className={"remove-image "}
                        src={removeIcon}
                      />
                    </td>
                  ) : null}
                </tr>
              );
            }
          })}
        </tbody>
      </table>
      <div>
        <Button
          className={"custom-btn"}
          onClick={() => props.toggleButtonClicked(shift.shiftId)}
        >
          {shift.isInputHidden ? languageData?.data?.shiftCreditCard?.show : languageData?.data?.shiftCreditCard?.hide}
        </Button>
        {!shift.isInputHidden && (
          <Button
            className={"custom-btn"}
            disabled={shift.isSaving}
            onClick={toggleShowModal}
          >
            {shift.isSaving && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {shift.isSaving ? languageData?.data?.shiftCreditCard?.saving : languageData?.data?.shiftCreditCard?.save}
          </Button>
        )}

        {!shift.isInputHidden && shift.companyBanks.length > 0 && (
          <Button
            className={"custom-btn"}
            disabled={shift.isSaving}
            onClick={toggleAddNewBankModal}
          >
            {languageData?.data?.shiftCreditCard?.addNewBank}
          </Button>
        )}
      </div>
      {shift.companyBanks.length > 0 && (
        <AddNewBankModal
          show={showAddNewBankModal}
          handleClose={toggleAddNewBankModal}
          onTrue={handleAddNewBank}
          buttonText={languageData?.data?.shiftCreditCard?.buttons.addBankModal.add}
          question={languageData?.data?.shiftCreditCard?.buttons.addBankModal.question}
          companyBanks={shift.companyBanks}
        />
      )}
      <Modal
        show={showModal}
        handleClose={toggleShowModal}
        onTrue={handleSaveInternally}
        buttonText={languageData?.data?.shiftCreditCard?.buttons.saveModal.save}
        question={languageData?.data?.shiftCreditCard?.buttons.saveModal.question}
      ></Modal>
      <Modal
        show={showPostFailedModal}
        handleClose={toggleShowPostFailedModal}
        onTrue={handlePostFailedSaveInternally}
        buttonText={languageData?.data?.shiftCreditCard?.buttons.retryModal.retry}
        question={languageData?.data?.shiftCreditCard?.buttons.retryModal.question}
      />
    </div>
  );
};

// export default AvailableForCreditCardSaveShift;

function mapStateToProps(state: any) {
  // console.log(state);
  const { isLoggedIn } = state.authReducer ?? {};
  const { message } = state.messageReducer ?? {};
  const { user } = state.user ?? {};
  const { ...language } = state.languageReducer ?? {};
  return {
    isLoggedIn,
    message,
    user,
    language,
  };
}

// function mapDispatchToProps(dispatch: any): any {
//   return {
//     logout: () => dispatch({ type: "LOGOUT" }),
//   };
// }

export default connect(mapStateToProps)(AvailableForCreditCardSaveShift);
